module.exports = __webpack_public_path__ + "static/media/icn-creez.5f7fb1e3.svg";